import { DownloadOutlined } from "@ant-design/icons";
import { Form, Button } from "antd";
import PropTypes from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { DATASET_TYPES } from "@/constants/DatasetTypes";
import { useExportDataset } from "@/hooks/importToolXSLX";
import { useFormValidation } from "@/modules/form-validation";

import FilterSelect from "./FilterSelect";
import { useFilters } from "./hooks/useFilters";

const { useForm } = Form;

const DEFAULT_TYPES = ["form", "gps", "cartesian"];
const initialValues = { datasetTypes: DEFAULT_TYPES };
const defaultFilter = { ["filter[type]"]: DEFAULT_TYPES.join(",") };

const ExportDataset = ({ selectedTemplateId }) => {
  const { t } = useTranslation();
  const [form] = useForm();
  const { loading, handleExportDataset } = useExportDataset(selectedTemplateId);
  const [params, setFilters] = useFilters(defaultFilter);
  const [errors, setErrors] = useState({});
  const hasErrors = !!Object.keys(errors).length;

  const { validationErrors, validation } = useFormValidation(
    hasErrors,
    errors,
    ["filter.intervention_id", "filter.type"]
  );

  const onSubmit = async () => {
    const { errors } = await handleExportDataset("datasets", params);
    setErrors(errors ?? {});
  };

  const datasetTypesOptions = DATASET_TYPES.map((type) => ({
    value: type,
    label: t(`global:datasetTypes.${type}`),
    disabled: type === "validation", // exporting validation's dataset is not supported for now
  }));

  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={onSubmit}
      initialValues={initialValues}
    >
      <FilterSelect
        model="interventions"
        onChange={(value) => setFilters("intervention_id", value)}
        {...validation("filter.intervention_id")}
      />
      <FilterSelect
        mode="multiple"
        model="datasetTypes"
        onChange={(value) => setFilters("type", value)}
        options={datasetTypesOptions}
      />
      {validationErrors().others && (
        <Form.Item
          {...validation("others")}
          style={{ marginTop: "-30px", marginBottom: "10px" }}
        />
      )}

      <Button htmlType="submit" loading={loading} icon={<DownloadOutlined />}>
        {t("global:export")}
      </Button>
    </Form>
  );
};

ExportDataset.propTypes = {
  selectedTemplateId: PropTypes.number.isRequired,
};

export default ExportDataset;
